module.exports = __webpack_public_path__ + "img/portrait-067.25b6579a.jpg";